import { Pipe, PipeTransform } from '@angular/core';

import { DateRangePreset } from '@dpr/models';
import { convertDateToString } from '@shared/utils';

@Pipe({
  name: 'dateRangePresetComparer',
})
export class DateRangePresetComparerPipe implements PipeTransform {
  transform(
    range: DateRangePreset,
    predefinedRanges: DateRangePreset[],
    startDate: Date,
    endDate: Date
  ): boolean {
    // custom range
    if (range.isCustomRange) {
      // no other range matched
      return !predefinedRanges.some(
        (x) =>
          !x.isCustomRange &&
          this.compare(x.dateRange.startDate, startDate) &&
          this.compare(x.dateRange.endDate, endDate)
      );
    }

    return (
      this.compare(range.dateRange.startDate, startDate) &&
      this.compare(range.dateRange.endDate, endDate)
    );
  }

  private compare(first: Date, second: Date): boolean {
    // null or undefined values comparison or date values comparison
    return (
      first === second ||
      convertDateToString(first) === convertDateToString(second)
    );
  }
}
